var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import RouteHandler from "../App/RouteHandler";
import { actions } from "../BasicReducer";
import { enterLibrary, unsetDocuments, zoomIn, zoomOut } from "./actions/libraryActions";
import DocumentsList from "./components/DocumentsList";
import { requestState } from "./helpers/requestState";
import LibraryLayout from "./LibraryLayout";
import { wrapDispatch } from "../Multireducer";
import { withRouter } from "../componentWrappers";
import { trackPage } from "../App/GoogleAnalytics";

class Library extends RouteHandler {
  constructor(props, context) {
    super(props, context);
    this.superComponentWillReceiveProps = super.componentWillReceiveProps;

    const { dispatch } = context.store;
    wrapDispatch(dispatch, 'library')(enterLibrary());
    this.zoomIn = () => wrapDispatch(dispatch, 'library')(zoomIn());
    this.zoomOut = () => wrapDispatch(dispatch, 'library')(zoomOut());
    this.scrollCallback = this.scrollCallback.bind(this);
    this.state = { scrollCount: 0 };
  }

  static async requestState(requestParams, globalResources) {
    return requestState(requestParams, globalResources);
  }

  urlHasChanged(nextProps) {
    const nextSearchParams = new URLSearchParams(nextProps.location.search);
    const currentSearchParams = new URLSearchParams(this.props.location.search);
    return nextSearchParams.get('q') !== currentSearchParams.get('q');
  }

  componentWillUnmount() {
    this.emptyState();
  }

  componentDidUpdate(prevProps) {
    if (this.urlHasChanged(prevProps)) {
      this.getClientState(this.props);
    }
  }

  emptyState() {
    wrapDispatch(this.context.store.dispatch, 'library')(unsetDocuments());
    actions.set('library.sidepanel.quickLabelState', {});
  }

  scrollCallback(event) {
    if (event.target.className.includes('document-viewer')) {
      this.setState((prevState, _props) => ({
        scrollCount: prevState.scrollCount + 1
      }));
    }
  }

  render() {
    trackPage();
    return (/*#__PURE__*/
      _jsx(LibraryLayout, {
        sidePanelMode: this.props.sidePanelMode,
        scrollCallback: this.scrollCallback,
        scrollCount: this.state.scrollCount }, void 0, /*#__PURE__*/

      _jsx(DocumentsList, {
        storeKey: "library",
        CollectionViewer: this.props.viewer,
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        scrollCount: this.state.scrollCount }
      )
      ));

  }
}

const SSRLibrary = withRouter(Library);

export const LibraryCards = Object.assign(SSRLibrary, { requestState: Library.requestState });
export default Library;